var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="criteria-area">\n  <div class="criteria-label">\n    <label class="control-label">Signal criteria</label>\n  </div>\n  ';
 if (editable) { 
__p+='\n    <div class="form-group signal-criteria">\n      <div class="signal-criteria-frequency row">\n        <div class="col-auto d-flex align-items-center">\n          <input type="radio" name="any_or_all" value="all">\n        </div>\n        <div class="col-11">\n          <div class="input-group select2-bootstrap-prepend">\n            <div class="input-group-prepend">\n              <span class="input-group-text">\n                All of the above phrases are said\n              </span>\n            </div>\n            <select name="total_phrase_said_count" class="input-group-append"></select>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="form-group signal-criteria">\n      <div class="signal-criteria-count row">\n        <div class="col-auto d-flex align-items-center">\n         <input type="radio" name="any_or_all" value="any">\n      </div>\n      <div class="col-11">\n          <div class="input-group select2-bootstrap-append">\n            <select name="uniq_phrase_said_count"></select>\n            <div class="input-group-append">\n              <span class=" input-group-text">\n               of the above phrases are said\n             </span>\n           </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
 } else { 
__p+='\n    <div class="signal-criteria readonly">\n      ';
 if (model.get("any_or_all") === "all") { 
__p+='\n        All of the above phrases are said '+
((__t=( model.get("total_phrase_said_count") ))==null?'':__t)+
' time'+
((__t=( model.get("total_phrase_said_count") != 1 ? "s" : "" ))==null?'':__t)+
'\n      ';
 } else if (model.get("any_or_all") === "any") { 
__p+='\n        Any '+
((__t=( model.get("uniq_phrase_said_count") ))==null?'':__t)+
' of the above phrases are said\n      ';
 } 
__p+='\n    </div>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
};
